/* eslint-disable camelcase */
import calculateDistance from '../../../utils/calculateDistance';
import createCompanyCertifications from '../../../utils/createCompanyCertificates';
import createCompanyContacts from '../../../utils/createCompanyContacts';
import createCompanyServices from '../../../utils/createCompanyServices';
import { decimalDistanceToLocal } from '../../../utils/distanceToLocal';

export default function contractorPropsController(
  hit,
  agentServices,
  qualifications,
  loc,
  savedCategory,
  zip,
  analytics,
) {
  const {
    nid: id,
    title,
    url,
    field_number_of_reviews: votes,
    field_rating: rating,
    field_address,
    field_mail,
    field_phone,
    field_site,
    field_agent_services,
    field_company_certifications,
    _geoloc,
    field_image,
  } = hit;
  const contacts = createCompanyContacts(
    field_address,
    field_mail,
    field_phone,
    field_site,
    analytics,
  );
  const parsedAddress = JSON.parse(field_address);
  const geoLoc = loc?.[0]?.geometry?.location;
  const metricsConfig = {
    ca: Drupal.t('KM'),
    us: Drupal.t('MI'),
  };
  const distanceInMeters = calculateDistance(
    _geoloc.lat,
    _geoloc.lng,
    geoLoc?.lat || geoLoc?.lat(),
    geoLoc?.lng || geoLoc?.lng(),
  );
  const distance = geoLoc
    ? decimalDistanceToLocal(distanceInMeters, metricsConfig)
    : '';
  const meta = [
    `${parsedAddress.field_address_locality}, ${parsedAddress.field_address_administrative_area}`,
    distance,
  ];
  const imageData = field_image && JSON.parse(field_image);
  const certifications =
    field_company_certifications &&
    createCompanyCertifications(field_company_certifications, qualifications);
  const selectedCategoryValue = savedCategory?.value[0]
    ? savedCategory?.value[0]
    : savedCategory?.value[1];
  const savedCategroyIndex = certifications?.indexOf(
    certifications.find((certificate) =>
      certificate.productId.find((product) =>
        product.id.includes(selectedCategoryValue),
      ),
    ),
  );
  return {
    id,
    title,
    url,
    ...(rating && votes ? { rating: { rating: Number(rating), votes } } : {}),
    ...(imageData
      ? {
          image: {
            damImage: imageData?.external_url,
            altText: imageData.alt || '',
            responsiveImageStyle: 'contractor_card',
            imagePath: imageData?.url,
          },
        }
      : {}),
    meta,
    contacts: {
      items: contacts,
      analytics: {
        event: 'find_a_pro_profile_clicked',
        contentType: 'find_a_pro_listing',
        zip,
        title,
        productCategory: savedCategory,
      },
    },
    services: createCompanyServices(field_agent_services, agentServices),
    ...(certifications
      ? {
          tag: {
            label: certifications[savedCategroyIndex]
              ? certifications[savedCategroyIndex].label
              : certifications[0].label,
          },
          credentials: {
            label: Drupal.t('CertainTeed Credentials'),
            link: {
              href: '/why-credentialing-matters',
              title: Drupal.t('Learn why credentialing matters'),
            },
            items: certifications.slice(0, 2),
          },
        }
      : {}),
  };
}
